<template>
  <div>
    <v-row>
      <v-col>
        <BudgetForm
          :title="$capitalize($tc('model.products_new_repair_title'))"
          objective="reparation"
          :loading="loading"
          @submit="handleCreateBudget"
          ref="budgetForm"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import BudgetForm from "@/components/Budget/BudgetForm";

export default {
  components: {
    BudgetForm
  },

  data() {
    return {
      loading: false
    };
  },

  methods: {
    async handleCreateBudget(payload) {
      const productId = this.$route.params.product_id;
      this.loading = true;
      try {
        const response = await this.$http.post(
          `/products/${productId}/budgets`,
          {
            product_budget: {
              objective: "reparation",
              additional_value: payload.additionalValue,
              vat_percentage: payload.vat_percentage,
              repair_items: payload.budgetItems.map(item => ({
                ...item,
                labor_quantity: parseFloat(
                  item.labor_quantity.replace(",", ".")
                )
              }))
            }
          }
        );
        await this.$store.dispatch("product/loadReparations", {
          productId
        });
        this.$store.commit("product/setLastReparation", response.data);
        this.$router.push({
          name: "ProductReparationDataLatest"
        });
      } catch (error) {
        this.$store.commit(
          "error",
          this.$capitalize(this.$tc('model.products_no_send_budget_message'))
        );
      } finally {
        this.loading = false;
      }
    }
  },

  watch: {
    lastReparation: function(value) {
      if (!value) {
        this.$refs.budgetForm.fillNewBudget();
      } else {
        this.$refs.budgetForm.fillBudget({ ...value });
      }
    }
  },

  computed: {
    lastReparation() {
      return this.$store.getters["product/getReparationByVersion"]("latest");
    }
  },

  mounted() {
    const lastReparation = this.$store.getters[
      "product/getReparationByVersion"
    ]("latest");
    if (lastReparation) {
      this.$refs.budgetForm.fillBudget({ ...lastReparation });
    } else {
      this.$refs.budgetForm.fillNewBudget();
    }
  }
};
</script>
